export const selectColor = (state) => state.exam.color;
